// components
import { IconComponent } from '@centria-ui-atoms/icon-component'
import { Typography } from '@centria-ui-atoms/typography'
import { Skeleton } from '@centria-ui-atoms/skeleton'

// primeComponents
import { Dropdown as PrDropdown } from 'primereact/dropdown'

// Styles
import classes from './styles.module.scss'

// Types
import type { DropdownProps as PrDropdownProps } from 'primereact/dropdown'
import type { InputsEnum, variantsEnum } from '@centria-ui/commons/enums'
import type { IconName } from '@centria-ui-atoms/icon-component'
import type { FC } from 'react'

export interface DropdownProps extends PrDropdownProps {
  label?: string
  icon?: IconName
  hideTrigger?: boolean
  wrapperClassName?: string
  inputVariant?: keyof typeof InputsEnum
  inputColor?: typeof variantsEnum.light | typeof variantsEnum.white
}

export const Dropdown: FC<DropdownProps> = ({
  icon,
  label,
  className = '',
  hideTrigger = false,
  inputColor = 'light',
  wrapperClassName = '',
  inputVariant = 'block',
  ...props
}) => {
  const append = () => {
    if (typeof document !== 'undefined') return document.body
    else return 'self'
  }

  return (
    <div className={wrapperClassName} data-cy='dropdown'>
      {label && (
        <Typography
          Tag='label'
          fontSize='small'
          className='mb-1'
          htmlFor={props.id}>
          {label}
        </Typography>
      )}
      {!props?.options ? (
        <div className='d-flex'>
          <Skeleton height='48px' width='100%' radius='lg' />
        </div>
      ) : (
        <div className={`${classes.dropdownContainer} ${className}`}>
          <div
            className={`${classes[`dropdownBar_${inputVariant}`]} ${
              classes[`dropdownBar_${inputColor}`]
            }`}>
            {icon && <IconComponent icon={icon} className={classes.icon} />}
            <PrDropdown
              appendTo={append()}
              className={`${classes.dropdown} ${
                hideTrigger && classes.hideTrigger
              }`}
              panelClassName={classes.dropdownPanel}
              {...props}
            />
          </div>
        </div>
      )}
    </div>
  )
}
